import { useSyncExternalStore, type ReactNode } from "react";
import { appConfig } from "@/config";
import { ServerInfoBadge } from "./ServerInfoBadge";
import { serverInfoController } from "@/app/serverInfoController";
import { toServerInfoBadgeState } from "./serverInfoBadgeState";

type ServerInfoIndicatorProps = {
  collapsed: boolean;
};

// 표시 컴포넌트는 폴링 컨트롤러의 공유 스냅샷만 구독한다. 라우트가 바뀌어 다시 mount되어도
// 타이머와 직전 값은 모듈 컨트롤러에 남는다. 그래서 GNB마다 네트워크 요청이 생기지 않는다.
export function ServerInfoIndicator({ collapsed }: ServerInfoIndicatorProps): ReactNode {
  const snapshot = useSyncExternalStore(
    serverInfoController.subscribe,
    serverInfoController.getSnapshot,
    serverInfoController.getSnapshot,
  );
  return (
    <ServerInfoBadge
      state={toServerInfoBadgeState(snapshot)}
      frontendBuildId={appConfig.buildId}
      collapsed={collapsed}
    />
  );
}
